export function writeValueOnConfig(keyName: string, configName: string, value: any) {
    var info = localStorage[keyName];
    if (!info)
        info = {};
    else
        info = JSON.parse(info);
    info[configName] = value;
    localStorage[keyName] = JSON.stringify(info);
}

export function readValueFromConfig(keyName: string, configName: string): any {
    var info = localStorage[keyName];
    if (!info)
        return null;
    info = JSON.parse(info);
    let value = info[configName];
    if (value)
        return value;
    else
        return null;
}

export function randomString(n: number): string {
    var s = "";
    while (n > 0) {
        s = s + "1234567890QWERTYUIOPLKJHGFDSAZXCVBNM".charAt(Math.floor((Math.random() * 36)));
        n--;
    }
    Math.floor((Math.random() * 5));
    return s;
}

export function arrayContainsAndPush(keyName: string, id: number): boolean {
    var resp = false;
    var info = localStorage[keyName];
    var keys: number[];
    if (info) {
        keys = JSON.parse(info);
        if (keys.indexOf(id) == -1) {
            keys.push(id);
        } else
            resp = true;
    } else
        keys = [id];
    localStorage[keyName] = JSON.stringify(keys);
    return resp;
}

export function keyGen(tableName: string): number {
    var info = localStorage["keyTable"];
    if (info) {
        info = JSON.parse(info);
    } else
        info = {};
    if (info[tableName]) {
        info[tableName] = info[tableName] + 1;
    } else {
        info[tableName] = 1;
    }
    localStorage["keyTable"] = JSON.stringify(info);
    return info[tableName];
}

export class PushConfig {

    constructor(public serverIp: string) { }

}

export class PushMessage {

    constructor(public idMessage: number, public payload: any, public title: string, public text: string, public foreground: boolean) { }

}


// WEBPACK FOOTER //
// ./src/lib/util.ts